module.exports = SharedDependencies.React['host'];